import { FlagIcon } from "react-flag-kit";
import { FaStar } from "react-icons/fa";

const testimonials = [
    {
        id: 1,
        name: "Putu Chelsea Amelia Putri",
        company: "J-1 Program at Branson Missouri at Chateu on the Lake",
        country: "USA",
        countryCode: "US",
        photo: "/img/chelsea.webp",
        message:
            "NIEC always helps me with the research and prepare my document, and now I'm continuing my study in Canadian College, Vancouver, Canada, after doing my J-1 program."
    },
    {
        id: 2,
        name: "Raditya Tude",
        company: "J-1 Program at Broadmoor Resort, Colorado",
        country: "USA",
        countryCode: "US",
        photo: "/img/tude.webp",
        message:
            "The NIEC team and our consultants always take care of us, and finally I got my ticket to the US!."
    },
    {
        id: 3,
        name: "Ngurah",
        company: "Monarch Casino Resort and Spa Black Hawk Colorado",
        country: "USA",
        countryCode: "US",
        photo: "/img/ngurah.webp",
        message:
            "Di NIEC, kita sudah diberikan pelatihan untuk interview, jadi saya sangat berterima kasih kepada NIEC, karena sudah dibimbing untuk program J-1 ini."
    },
    // {
    //     id: 4,
    //     name: "Siti Aisyah",
    //     company: "Royal Palm Hotel",
    //     country: "UAE",
    //     countryCode: "AE",
    //     photo: "/img/students/siti.webp",
    //     message:
    //         "Lingkungan kerja multinasional membuat saya lebih percaya diri dan siap berkarier di luar negeri."
    // }
];

const TestimonialsSection = () => {
    return (
        <section className="testimonials">
            <div className="testimonials__container">
                <header className="testimonials__header">
                    <h2>Apa Kata Alumni Internship</h2>
                    <p>
                        Pengalaman nyata mereka yang telah mengikuti program magang
                        internasional di berbagai negara.
                    </p>
                </header>

                <div className="testimonials__grid">
                    {testimonials.map((item) => (
                        <article className="testimonial-card" key={item.id}>
                            {/* Header */}
                            <div className="testimonial-card__header">
                                <img
                                    src={item.photo}
                                    alt={item.name}
                                    className="testimonial-card__avatar"
                                />
                                <span className="testimonial-card__country">
                                    <span className="hp-flag hp-flag-2"><FlagIcon code={item.countryCode} size={10} /></span>
                                    {item.country}
                                </span>
                            </div>

                            {/* Body */}
                            <div className="testimonial-card__body">
                                <span className="d-flex justify-content-center testimoni-star"><FaStar /><FaStar /><FaStar /><FaStar /><FaStar /></span>
                                <p>“{item.message}”</p>
                            </div>

                            {/* Footer */}
                            <footer className="testimonial-card__footer">
                                <strong>{item.name}</strong>
                                <span>{item.company}</span>
                            </footer>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TestimonialsSection;